module.exports = __webpack_public_path__ + "static/media/home.4c6901db.svg";